module.exports = __webpack_public_path__ + "static/media/WaywardCreaturesAlternatives.3d8f9e9d.jpg";